import { useCallback, useContext, useEffect, useRef } from 'react';
import DeliveryBanner from '@/common/helios/DeliveryUnavailableBanner';
import { noDeliveryBannerEvent } from '~/constants/eventNames';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useUserId, useUserLocation } from '~/context/common/UserContext';
import { useUserDeliveryInfo } from '~/context/srp/InventoryContext';
import ModalContext from '~/context/srp/ModalContext';
import { useDDAddAction } from '~/hooks/common/telemetry';

function useSendEvent(shouldSend: boolean, zip: string) {
  const userId = useUserId();
  const trackEvent = useTrackEvent();

  const zipRef = useRef(zip);
  useEffect(() => {
    zipRef.current = zip;
  }, [zip]);

  useEffect(() => {
    if (!shouldSend) return;

    trackEvent(noDeliveryBannerEvent, {
      userId,
      zip: zipRef.current
    });
  }, [shouldSend, trackEvent, userId]);
}

export default function DeliveryUnavailableBanner() {
  const { setGeolocationModalOpen } = useContext(ModalContext);
  const trackEvent = useTrackEvent();
  const { isDeliveryAllowed, isPickupAllowed } = useUserDeliveryInfo() ?? {};
  const { zip = '' } = useUserLocation();

  const handleClick = useCallback(() => {
    trackEvent('Undeliverable banner - button clicked');
    setGeolocationModalOpen(true);
  }, [setGeolocationModalOpen, trackEvent]);

  const shouldDisplayBanner =
    isDeliveryAllowed === false && zip !== null && isPickupAllowed === false;

  useSendEvent(shouldDisplayBanner, String(zip));
  useDDAddAction(noDeliveryBannerEvent, shouldDisplayBanner);

  return shouldDisplayBanner ? (
    <div className="mx-auto">
      <DeliveryBanner openCallback={handleClick} zip={zip} />
    </div>
  ) : null;
}
